import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import CheckBox from '~/components/common/Checkbox'
import { COLORS } from '~/themes/common'
import { htmlDecode } from '~/utils/utility'

const themeStyle = () => ({
  categoriesContainer: {
    marginTop: 24,
    padding: 4,
    borderRadius: 5,
    backgroundColor: '#EDF1FB',
    border: '1px solid #B4BFD9',
  },
  categories: {
    minHeight: 60,
    maxHeight: 200,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 6,
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5,
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 10,
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: COLORS.palette.secondaryBlue2,
    },
  },
  // Cova Style
  disabledCategory: {
    backgroundColor: COLORS.gray.disableGray2,
    border: `1px solid ${COLORS.gray.disableGray}`,
  },
  disabledCheckbox: {
    backgroundColor: COLORS.gray.disableGray2,
    marginLeft: '-3px',
  },
})

const Categories = ({
  classes,
  allCategories,
  onCheck,
  className,
  values,
  disabled,
}) => {
  const selectedIds = useMemo(
    () => (values || []).map((s) => s.id),
    [values?.length],
  )

  const renderItems = useCallback(
    (item) => (
      <div style={{ display: 'flex' }} key={`__${item.name}${item.id}`}>
        {item.level > 1 ? (
          <>
            <span style={{ marginLeft: (item.level - 1) * 25 }} />
            <SubdirectoryArrowRightIcon
              color={disabled ? 'disabled' : 'inherit'}
              style={{
                fontSize: '14px',
                marginTop: 10,
                marginLeft: 5,
              }}
            />
          </>
        ) : null}
        <CheckBox
          key={item.id}
          label={item.name ? htmlDecode(item.name) : ''}
          whiteColor
          checked={selectedIds.includes(item.id)}
          onChange={(e) => onCheck(item.id, e.target.checked)}
          disabled={disabled}
          className={clsx({ [classes.disabledCheckbox]: disabled })}
        />
      </div>
    ),
    [disabled, selectedIds, onCheck],
  )

  return (
    <div
      id="checkboxes"
      className={clsx(
        classes.categoriesContainer,
        { [classes.disabledCategory]: disabled },
        className,
      )}
    >
      <div className={classes.categories}>{allCategories.map(renderItems)}</div>
    </div>
  )
}

Categories.defaultProps = {
  allCategories: [],
  onCheck: () => {},
  className: '',
  values: [],
  disabled: false,
}

Categories.propTypes = {
  classes: PropTypes.shape().isRequired,
  allCategories: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape()),
  ]),
  onCheck: PropTypes.func,
  className: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape()),
  disabled: PropTypes.bool,
}

export default withStyles(themeStyle)(Categories)
